import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '../../../config/constants';

const initialState = {
  data: {},
  status: STATUS.NONE,
};

export const signInSlice = createSlice({
  name: 'signin',
  initialState,
  reducers: {
    resetState: (state) => {
      state.status = STATUS.NONE;
      state.data = undefined;
    },
    readyForNextState: (state) => {
      state.status = STATUS.NONE;
      state.error = undefined;
    },
    request: (state) => {
      state.status = STATUS.FETCHING;
    },
    success: (state) => {
      state.status = STATUS.SUCCESS;
    },
    failure: (state, action) => {
      const { payload: error } = action;
      state.status = STATUS.FAILURE;
      state.error = error;
    },
  },
});

export const { resetState, readyForNextState, request, success, failure } =
  signInSlice.actions;

export const status = (state) => state.signin.status;

export const data = (state) => state.signin.data;

export const error = (state) => state.signin.error;

export default signInSlice.reducer;
